const CONVERT_PAGE_TYPES = {
    HOME: 'home',
    CATEGORY: 'category',
    PRODUCT: 'product',
    SEARCH: 'search',
    CART: 'cart',
    CHECKOUT: 'checkout',
    SUCCESS: 'success',
    ACCOUNT: 'account',
    CMS: 'cms',
    OTHER: 'other',
};

const CONVERT_VIP_PLACES = {
    PRODUCT_PAGE: 'product_page',
    BASKET: 'basket',
    CHECKOUT: 'checkout',
    SUCCESS_PAGE: 'success_page',
};

const CONVERT_REVENUE_GOAL_ID = '100161295';

const CONVERT_GOALS = {
    PURCHASE_REVENUE: '100161295',
    ADD_TO_CART_ANY: '100161810',
    ADD_TO_CART_PRODUCT_PAGE: '100161838',
    VIEWED_BASKET: '100161841',
    REACHED_CHECKOUT: '100161842',
    VIEWED_PRODUCT_PAGE: '100161843',
    VIP_SIGNUP: '100161844',
};

const CONVERT_ADD_TO_CART_SKU_GOALS = {
    'CONFSKU947180': '100161839'
};
const CONVERT_PURCHASE_SKU_GOALS = {
    'CONFSKU947180': '100161840'
};

const convertLoad = () => {
    window._conv_q = window._conv_q || [];

    window['_conv_page_type'] = '';
    window['_conv_category_id'] = '';
    window['_conv_category_name'] = '';
    window['_conv_product_sku'] = '';
    window['_conv_product_name'] = '';
    window['_conv_product_price'] = '';
    window['_conv_customer_id'] = '';
    window['_conv_custom_v1'] = '';
    window['_conv_custom_v2'] = '';
    window['_conv_custom_v3'] = '';
    window['_conv_custom_v4'] = '';

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `//cdn-4.convertexperiments.com/v1/js/100110340-100110837.js?environment=${process.env.ENVIRONMENT}`;
    document.head.appendChild(script);
};

const convertPush = (goalId, customDimensions = []) => {
    if (goalId) {
        window._conv_q.push({ what: 'triggerConversion', params: { goalId, customDimensions } });
    }
};

const convertPageType = ({
    pageType = '',
    categoryId = '',
    categoryName = '',
    productSKU = '',
    productName = '',
    priceRange: {
        minimum_price: {
            regular_price: { value } = {}
        } = {}
    } = {},
}) => {
    window['_conv_page_type'] = pageType;
    window['_conv_category_id'] = categoryId;
    window['_conv_category_name'] = categoryName;
    window['_conv_product_sku'] = productSKU;
    window['_conv_product_name'] = productName;
    window['_conv_product_price'] = value || '';

    if (pageType === CONVERT_PAGE_TYPES.PRODUCT) {
        convertPush(CONVERT_GOALS.VIEWED_PRODUCT_PAGE);
    }

    if (pageType === CONVERT_PAGE_TYPES.CART) {
        convertPush(CONVERT_GOALS.VIEWED_BASKET);
    }

    if (pageType === CONVERT_PAGE_TYPES.CHECKOUT) {
        convertPush(CONVERT_GOALS.REACHED_CHECKOUT);
    }
};

const convertAddToCart = cartItems => {
    convertPush(CONVERT_GOALS.ADD_TO_CART_ANY);

    if (window._conv_page_type === CONVERT_PAGE_TYPES.PRODUCT) {
        convertPush(CONVERT_GOALS.ADD_TO_CART_PRODUCT_PAGE);
    }

    cartItems.forEach(({ sku, parent_sku }) => {
        convertPush(CONVERT_ADD_TO_CART_SKU_GOALS[sku]);
        convertPush(CONVERT_ADD_TO_CART_SKU_GOALS[parent_sku]);
    });
};

const convertPurchase = ({
    number,
    items,
    total: {
        grand_total,
    },
    enhanced_conversion_data: {
        item_count,
    }
}) => {
    items.forEach(({ product, product_sku }) => {
        convertPush(CONVERT_PURCHASE_SKU_GOALS[product?.sku]);
        convertPush(CONVERT_PURCHASE_SKU_GOALS[product_sku]);
    });

    window._conv_q.push(['pushRevenue', grand_total.value, item_count, CONVERT_REVENUE_GOAL_ID, 'force_multiple', number]);
};

const convertLoginUser = customerId => {
    window['_conv_customer_id'] = customerId;
};

const convertVipSignUp = customDimensions => {
    convertPush(CONVERT_GOALS.VIP_SIGNUP, [[customDimensions]]);
};

export {
    CONVERT_PAGE_TYPES,
    CONVERT_VIP_PLACES,
    convertLoad,
    convertAddToCart,
    convertPurchase,
    convertPageType,
    convertLoginUser,
    convertVipSignUp,
}
